<template >	
	<div>
	<v-dialog slot="activator" v-model="dialog" persistent max-width="500">
        <v-btn slot="activator" icon>
        	<v-icon :small="small" color="grey darken-2">{{this.icon ? this.icon : 'add_circle_outline'}}</v-icon>
        </v-btn>
        <v-card >
        	<v-toolbar><v-toolbar-title>
        		DEPARTMENT
        	</v-toolbar-title></v-toolbar>
        	<v-card-title class="body-2" color="black">
         		<v-layout column class="pl-1 pt-2">
	         		<v-flex>
	         			<v-layout row>
	         				<v-flex xs2>Room:</v-flex>
	         				<v-flex v-if="room">{{room.number}}</v-flex>
         				</v-layout>
         			</v-flex>
         		</v-layout>
         	</v-card-title> 
        	<v-card-text class="pb-5">
        		<v-layout >
        			<v-flex xs8>
						<v-autocomplete
							:items="depts"
							item-text="deptNameAndID"
							item-value="deptID"
							v-model="select"
							cache-items
							class=""
							flat
							light
							hide-no-data
							hide-details
							label="Enter Department Name"
							solo-inverted
							autofocus
						></v-autocomplete>
					</v-flex>
					<v-flex xs4 class="ml-3">
			          	<v-text-field
			            	label="Percentage"
			            	v-model="percentage"
			            	solo-inverted
			          	></v-text-field>
		      		</v-flex>
		  		</v-layout>
		        
			</v-card-text>
        	<v-card-actions>
	          	<v-spacer></v-spacer>
	          	<v-btn color="green darken-1" flat @click.native="dialog=false">Cancel</v-btn>
	          	<v-btn v-if="add" color="green darken-1" flat @click.native="addDept">Add</v-btn>
	          	<v-btn v-if="!add" color="green darken-1" flat @click.native="modDept">Save</v-btn>
	        </v-card-actions>
    	</v-card>
    </v-dialog>
	</div>
    
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { AUTH_COOKIE } from '@/store/modules/user'
import { AUTH_API_COOKIE } from '@/store/modules/user'
import jscookie from 'js-cookie'
import Vue from 'vue'

export default {
	props: [ 'add', 'icon', 'small', 'deptPCT', 'deptID', 'room' ],

	data () {
			return {
			checkbox: false,
			loading: false,
			items: [],
			search: null,
			select: this.deptPCT ? this.deptPCT.deptID : null,
			dialog: false,
			percentage: this.deptPCT ? this.deptPCT.percentage : null,
		}
	},

	computed: {
			...mapState({ 	depts: 	state => state.lists.depts			}),
	},

	methods: {
		...mapMutations(['setSnackText', ]),
		...mapActions([ 'updateRoomPercentage', 'insertRoomPercentage', 'fetchFullRoom', ]),
		
		addDept () {
			if (!this.select) { return }
			const payload = { key: this.room.key, deptID: this.select, percentage: this.percentage}
			this.insertRoomPercentage(payload).then((response) => { 
				this.refresh(response)	
			})			
			
			
		},		

		modDept () {
			if (!this.select) { return }
			const payload = { key: this.deptPCT.key, deptID: this.select, percentage: this.percentage}
			this.updateRoomPercentage(payload).then((response) => {
				this.refresh(response)				
			})			
			
		},	

		refresh(response) {
			if (response == "Saved") {
					this.$emit('success', true)
					// reset and refresh things
					this.$emit('updateLoading', true)
					this.$emit('refresh')
					this.dialog = false
					this.select = null
					this.percentage = null
			} else {
				this.setSnackText(response)
			}
		},

	}
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/forms/AddDepartment.vue